export const RESET_STORE = 'RESET_STORE';

export const apiResponse = '@@response';
export const apiRequest = '@@request';
export const reportRequest = '@@requestReport';
export const reportResponse = '@@responseReport';
export const error = 'error';

/** Generic application action types */
export const CHECK_CREDENTIALS = `${apiRequest}/CHECK_CREDENTIALS`;
export const CHECK_CREDENTIALS_SUCCESS = `${apiResponse}/CHECK_CREDENTIALS_SUCCESS`;
export const CHECK_CREDENTIALS_FAILURE = `${apiResponse}/${error}/CHECK_CREDENTIALS_FAILURE`;
export const SET_STEP_TITLE = 'SET_STEP_TITLE';
export const ADD_WHITELIST_PAGE = 'ADD_WHITELIST_PAGE';
export const DELETE_WHITELIST_PAGE = 'DELETE_WHITELIST_PAGE';
export const CLEAR_WHITELIST_PAGES = 'CLEAR_WHITELIST_PAGES';
export const SET_ERROR_PAGE = 'SET_ERROR_PAGE';
export const REQUEST_REMOVE_ACCESS = `${apiRequest}/REMOVE_SESSION`;
export const REMOVE_ACCESS_SUCCESS = `${apiResponse}/REMOVE_SESSION_SUCCESS`;
export const REMOVE_ACCESS_FAILURE = `${apiResponse}/REMOVE_SESSION_FAILURE`;
export const SET_WEBVIEW_MODE = 'SET_WEBVIEW_MODE';
export const SET_INPUT_ERROR = 'SET_INPUT_ERROR';
export const CLEAR_INPUT_ERROR = 'CLEAR_INPUT_ERROR';
export const SET_IS_FIRST_CONNECTION = 'SET_IS_FIRST_CONNECTION';

/** Probes action types */
export const RECORDING_PROBE_STARTED = 'RECORDING_PROBE_STARTED';
export const RECORDING_PROBE_FINISHED = 'RECORDING_PROBE_FINISHED';
export const SENDING_PROBES_STARTED = `${reportRequest}/SENDING_PROBES`;
export const SENDING_PROBES_SUCCESS = `${reportResponse}/SENDING_PROBES_SUCCESS`;
export const SENDING_PROBES_FAILURE = `${reportResponse}/${error}/SENDING_PROBES_FAILURE`;

/** Captcha action types */
export const ADD_IMAGE_CAPTCHA = 'ADD_IMAGE_CAPTCHA';
export const REMOVE_LAST_IMAGE_CAPTCHA = 'REMOVE_LAST_IMAGE_CAPTCHA';
export const CLEAR_CAPTCHA = 'CLEAR_CAPTCHA';
export const CREATE_CAPTCHA = `${apiRequest}/GENERATE_CAPTCHA`;
export const CREATE_CAPTCHA_SUCCESS = `${apiResponse}/GENERATE_CAPTCHA_SUCCESS`;
export const CREATE_CAPTCHA_FAILURE = `${apiResponse}/${error}/GENERATE_CAPTCHA_FAILURE`;
export const INVALID_CAPTCHA = `${apiResponse}/INVALID_CAPTCHA`;
export const NOT_FINISHED_CAPTCHA = `${apiResponse}/NOT_FINISHED_CAPTCHA`;

/** Identification step action types */
export const REQUEST_ACCESS = `${apiRequest}/GET_ACCESS`;
export const RECEIVE_ACCESS_NEW_SESSION = `${apiResponse}/ACCESS_NEW_SESSION`;
export const RECEIVE_ACCESS_FAILURE = `${apiResponse}/ACCESS_FAILURE`;
export const RECEIVE_ACCESS_BYPASS = `${apiResponse}/ACCESS_BYPASS`;
export const CREATE_IDENTITIES = `${apiRequest}/CREATE_IDENTITIES`;
export const CREATE_IDENTITIES_SUCCESS = `${apiResponse}/CREATE_IDENTITIES_SUCCESS`;
export const CREATE_IDENTITIES_FAILURE = `${apiResponse}/${error}/CREATE_IDENTITIES_FAILURE`;

/** Contact choice step action types */
export const GET_CONTACTS = `${apiRequest}/GET_CONTACTS`;
export const GET_CONTACTS_SUCCESS = `${apiResponse}/GET_CONTACTS_SUCCESS`;
export const GET_CONTACTS_FAILURE = `${apiResponse}/${error}/GET_CONTACTS_FAILURE`;
export const GET_IDENTITIES = `${apiRequest}/GET_IDENTITIES`;
export const GET_IDENTITIES_SUCCESS = `${apiResponse}/GET_IDENTITIES_SUCCESS`;
export const GET_IDENTITIES_FAILURE = `${apiResponse}/${error}/GET_IDENTITIES_FAILURE`;
export const SET_SELECTED_CONTACT = 'SET_SELECTED_CONTACT';
export const REQUEST_DELETE_CONTACTS_LIST = `${apiRequest}/REMOVE_CONTACTS`;
export const DELETE_CONTACTS_LIST_SUCCESS = `${apiResponse}/REMOVE_CONTACTS_SUCCESS`;
export const DELETE_CONTACTS_LIST_FAILURE = `${apiResponse}/${error}/REMOVE_CONTACTS_FAILURE`;
export const CLEAR_CONTACTS = 'CLEAR_CONTACTS';

/** Otp code step action types */
export const CREATE_OTP = `${apiRequest}/CREATE_OTP`;
export const CREATE_OTP_SUCCESS = `${apiResponse}/CREATE_OTP_SUCCESS`;
export const CREATE_OTP_FAILURE = `${apiResponse}/${error}/CREATE_OTP_FAILURE`;
export const CHECKING_OTP = `${apiRequest}/CHECKING_OTP`;
export const CHECK_OTP_SUCCESS = `${apiResponse}/CHECKING_OTP_SUCCESS`;
export const CHECK_OTP_FAILURE = `${apiResponse}/${error}/CHECKING_OTP_FAILURE`;
export const OTP_IS_BLACKLISTED = 'OTP_IS_BLACKLISTED';
export const RETRY_OTC_SUCCESS = `${apiResponse}/RETRY_OTC_SUCCESS`;

/** Reset password action types */
export const INIT_PASSWORD_RULES = 'INIT_PASSWORD_RULES';
export const UPDATE_PASSWORD_PENDING = `${apiRequest}/UPDATE_PASSWORD`;
export const UPDATE_PASSWORD_SUCCESS = `${apiResponse}/UPDATE_PASSWORD_SUCCESS`;
export const UPDATE_PASSWORD_FAILURE = `${apiResponse}/${error}/UPDATE_PASSWORD_FAILURE`;
export const CHECK_PROPAGATION_PARTNERS = `${apiRequest}/CHECK_PARTNERS_UPDATE_PASSWORD`;
export const SET_CNIL_ERROR = 'SET_CNIL_ERROR';
export const CLEAR_CNIL = 'CLEAR_CNIL';
export const UPDATE_CNIL = 'UPDATE_CNIL';

/** Add contact action types */
export const REQUEST_UPDATE_CONTACTS = `${apiRequest}/UPDATE_CONTACTS`;
export const RECEIVE_UPDATE_CONTACTS_SUCCESS = `${apiResponse}/UPDATE_CONTACTS_SUCCESS`;
export const RECEIVE_UPDATE_CONTACTS_FAILURE = `${apiResponse}/${error}/UPDATE_CONTACTS_FAILURE`;
export const SET_CONTACT_FIELDS = 'SET_CONTACT_FIELDS';

/** Letter action types */
export const GET_LETTER_ATTEMPTS_EXCEEDED = 'GET_LETTER_ATTEMPTS_EXCEEDED';
export const GET_LETTER_PENDING = 'GET_LETTER_PENDING';
export const REQUEST_SENDING_LETTER = `${apiRequest}/SEND_LETTER`;
export const SEND_LETTER_SUCCESS = `${apiResponse}/SEND_LETTER_SUCCESS`;
export const SEND_LETTER_FAILURE = `${apiResponse}/${error}/SEND_LETTER_FAILURE`;
export const SET_POSTAL_CODE_ERROR = 'SET_POSTAL_CODE_ERROR';
export const CLEAR_POSTAL_CODE_ERROR = 'CLEAR_POSTAL_CODE_ERROR';

/** Confirm action type */
export const REQUEST_CONTACT_DATA = `${apiRequest}/GET_CONTACT_DATA`;
export const GET_CONTACT_DATA_SUCCESS = `${apiResponse}/GET_CONTACT_DATA_SUCCESS`;
export const RECEIVE_CONTACT_DATA_FAILURE = `${apiResponse}/${error}/GET_CONTACT_DATA_FAILURE`;

/** Error action type */
export const HANDLE_ERROR_BOUNDARY = 'HANDLE_ERROR_BOUNDARY';
export const SENDING_ERROR_STARTED = `${reportRequest}/SENDING_ERROR`;
export const SENDING_ERROR_SUCCESS = `${reportResponse}/SENDING_ERROR_SUCCESS`;
export const SENDING_ERROR_FAILURE = `${reportResponse}/${error}/SENDING_ERROR_FAILURE`;
